import PreparationAnalysisListStore from './preparation.list';

export const preparationAnalysis = {
  list: PreparationAnalysisListStore
};
